var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"src":_vm.url,"width":_vm.width,"height":_vm.height,"id":"spacesIframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }